(() => {
  const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');

  function enhanceCollectionToolbar(root = document) {
    if (!document.body.matches('[data-template^="collection"]') && !document.querySelector('collection-component')) return;

    root.querySelectorAll('.facets-toggle').forEach((toolbar) => {
      if (toolbar.dataset.ahToolbarReady === 'true') return;
      const mobileControls = toolbar.querySelector('.facets-mobile-wrapper');
      if (!mobileControls) return;

      const drawer = document.querySelector('#filters-drawer');
      const sortInputs = [...(drawer?.querySelectorAll('input[name="sort_by"]') || [])];
      if (!sortInputs.length) return;

      const wrapper = document.createElement('label');
      wrapper.className = 'ah-mobile-sort';
      wrapper.innerHTML = '<span>Sort</span><select aria-label="Sort products"></select>';
      const select = wrapper.querySelector('select');

      const seen = new Set();
      sortInputs.forEach((input) => {
        if (seen.has(input.value)) return;
        seen.add(input.value);
        const label = input.closest('label')?.textContent?.trim() || input.dataset.optionName || input.value;
        const option = document.createElement('option');
        option.value = input.value;
        option.textContent = label;
        option.selected = input.checked;
        select.appendChild(option);
      });

      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });

      mobileControls.replaceChildren(wrapper);
      toolbar.dataset.ahToolbarReady = 'true';
    });
  }

  function enhanceCareNavigation(root = document) {
    root.querySelectorAll('[data-care-navigation]').forEach((navigation) => {
      if (navigation.dataset.ahCareReady === 'true') return;
      const track = navigation.querySelector('[data-care-track]');
      const previous = navigation.querySelector('[data-care-prev]');
      const next = navigation.querySelector('[data-care-next]');
      if (!track) return;

      const updateButtons = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 2);
        if (previous) previous.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= maxScroll;
      };

      previous?.addEventListener('click', () => track.scrollBy({ left: -Math.max(220, track.clientWidth * 0.72), behavior: 'smooth' }));
      next?.addEventListener('click', () => track.scrollBy({ left: Math.max(220, track.clientWidth * 0.72), behavior: 'smooth' }));
      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons, { passive: true });

      const active = track.querySelector('[aria-current="page"]');
      window.requestAnimationFrame(() => {
        if (active && MOBILE_QUERY.matches) active.scrollIntoView({ behavior: 'instant', inline: 'center', block: 'nearest' });
        updateButtons();
      });

      navigation.dataset.ahCareReady = 'true';
    });
  }

  function init(root = document) {
    enhanceCollectionToolbar(root);
    enhanceCareNavigation(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node instanceof Element) init(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
